import React from 'react';
import AutoTranslate from '../AutoTranslate';
import './Style.css';

const RadioButtonGroup = ({
  label,
  name,
  value,
  onChange,
  error,
  options,
  required = false,
  targetLanguage
}) => {
  return (
    <div className='modern-form-group'>
      <label className='modern-form-label'>
        <AutoTranslate targetLanguage={targetLanguage}>{label}</AutoTranslate>
        {required && <span style={{ color: "#dc3545", fontWeight: "bold" }}>&#42;</span>}
      </label>
      <div className={`radio-button-group `}>
        {options.map((option) => (
          <label key={option.value} className={`radio-button-label ${error ? 'error-field' : ''}`}>
            <input
              type='radio'
              name={name}
              value={option.value}
              checked={value === option.value && value !== ""}
              onChange={(e) => onChange(name, e.target.value === 'true')}
              className='radio-button-input'
            />
            <span className='radio-button-text'>
              <AutoTranslate targetLanguage={targetLanguage}>{option.label}</AutoTranslate>
            </span>
          </label>
        ))}
      </div>
      <div className="error-message">
        {error ? (
          <AutoTranslate targetLanguage={targetLanguage}>{error}</AutoTranslate>
        ) : (
          <span>&nbsp;</span>
        )}
      </div>
    </div>
  );
};

export default RadioButtonGroup;
